export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const BASE_URL = process.env.REACT_APP_BASE_URL; //!API BASE URL
export const BASE_URL_IMG = process.env.REACT_APP_BASE_URL_IMG; //!Image BASE URL
export const DEBUG_MODE = process.env.REACT_APP_DEBUG_MODE === "true" ? true : false;
export const RUPEES_SYMBOL = "₹";
const d = {
  product_gallery: [
    {
      id: 1,
      productId: 2,
      image: "1759901805216.jpg",
      doc_type: "image/jpeg",
      status: true,
      createdBy: 3,
      updatedBy: 3,
      createdAt: "2025-10-08T05:36:45.416Z",
      updatedAt: "2025-10-08T05:36:45.416Z",
    },
    {
      id: 2,
      productId: 2,
      image: "1759901805243.jpg",
      doc_type: "image/jpeg",
      status: true,
      createdBy: 3,
      updatedBy: 3,
      createdAt: "2025-10-08T05:36:45.453Z",
      updatedAt: "2025-10-08T05:36:45.453Z",
    },
    {
      id: 4,
      productId: 2,
      image: "1759913172476.png",
      doc_type: "image/png",
      status: true,
      createdBy: 2,
      updatedBy: 2,
      createdAt: "2025-10-08T08:46:12.603Z",
      updatedAt: "2025-10-08T08:46:12.603Z",
    },
  ],
};

export const discountTypes = [
  {
    value: "flat",
    label: "Flat",
  },
  {
    value: "percentage",
    label: "Percentage",
  },
];
export const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
export const SESSIONS = [
  { value: "morning", label: "Morning" },
  { value: "afternoon", label: "Afternoon" },
  { value: "evening", label: "Evening" },
  { value: "night", label: "Night" },
];
export const slotDuration = [
  { value: 5, label: "5 min" },
  { value: 10, label: "10 min" },
  { value: 15, label: "15 min" },
  { value: 20, label: "20 min" },
  { value: 25, label: "25 min" },
  { value: 30, label: "30 min" },
  { value: 35, label: "35 min" },
  { value: 40, label: "40 min" },
  { value: 45, label: "45 min" },
  { value: 50, label: "50 min" },
  { value: 55, label: "55 min" },
  { value: 60, label: "60 min" },
];
